// Shared colour palette used by clients + team members.
// Reorganised Sep 2026: added an extra "signature" row of 12 highly-distinct
// hues (magenta, chartreuse, cyan, hot-pink, etc.) so managers have plenty
// of options that don't look alike, and swapped near-duplicate pastels for
// hues that are easier to tell apart at a glance. 80 swatches total.
export const COLOR_PALETTE = [
    // Row 0 — extra signature brights (fresh + easy to differentiate on both light and dark UI)
    "#FF1744", "#FF9100", "#FFEA00", "#76FF03", "#00E676",
    "#1DE9B6", "#00E5FF", "#40C4FF", "#3D5AFE", "#651FFF",
    "#F50057", "#FF80AB",
    // Row 1 — bright, high-saturation "signature" colours (default picks)
    "#FF3D3D", "#FF6B00", "#FFB000", "#FFD400", "#B4E600",
    "#00C853", "#00B8A9", "#00A3FF", "#2962FF", "#8E24FF",
    "#D500F9", "#FF2D95",
    // Row 2 — deep jewel tones
    "#B71C1C", "#BF360C", "#E65100", "#F57F17", "#33691E",
    "#004D40", "#006064", "#01579B", "#0D47A1", "#4527A0",
    "#6A1B9A", "#AD1457",
    // Row 3 — mid tones, useful for tags on white / dark UIs alike
    "#E53935", "#FB8C00", "#F9A825", "#7CB342", "#43A047",
    "#00ACC1", "#039BE5", "#1E88E5", "#3949AB", "#5E35B1",
    "#8E24AA", "#D81B60",
    // Row 4 — soft pastels (client dossiers etc). Reworked so no two are
    // nearly-identical creams / mint-blues — every swatch now has a
    // distinct hue.
    "#FFB3BA", "#FFCC80", "#FFF176", "#DCE775", "#AED581",
    "#80CBC4", "#4DD0E1", "#81D4FA", "#9FA8DA", "#B39DDB",
    "#CE93D8", "#F48FB1",
    // Row 5 — muted / earthy neutrals (subtle backgrounds)
    "#8D6E63", "#A1887F", "#795548", "#607D8B", "#546E7A",
    "#455A64", "#37474F", "#4E342E",
    // Row 6 — very dark / near-black (last-resort variety)
    "#212121", "#263238", "#1B5E20", "#3E2723",
];
